import { MARQUEE_ITEMS } from '../lib/site';

const Row = () => (
    <div className="flex shrink-0 items-center">
        {MARQUEE_ITEMS.map((item) => (
            <span key={item} data-testid="marquee-item" className="flex items-center">
                <span className="font-mono text-xs sm:text-sm uppercase tracking-[0.3em] text-[#15132B] whitespace-nowrap px-8">
                    {item}
                </span>
                <span className="inline-block w-1.5 h-1.5 rotate-45 bg-[#15132B]/40" />
            </span>
        ))}
    </div>
);

export default function EditorialMarquee() {
    return (
        <div
            data-testid="editorial-marquee"
            className="relative bg-[#8A93F5] border-y border-[#15132B]/10 py-4 overflow-hidden"
        >
            <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
                <Row />
                <Row />
            </div>
        </div>
    );
}
